import React from 'react';
import PropTypes from 'prop-types';

import { Translate } from '@hydra/common/components';
import { Criterium, CriteriumSkeleton, CriteriumTable } from '@hydra/common/criterium';
import { useReviewContext } from '@hydra/common/context';

export const MobileCompatibility = ({ criterium }) => {
  const { data, url } = criterium;
  const { variant } = useReviewContext();

  const head = [
    <Translate content='table_internal' key='table_internal' />,
    <Translate content='plugin_content' key='plugin_content' />
  ];
  const rows = data.plugins.map(({ type, snippet }) => ([type, snippet]));

  const content = data.plugins.length === 0
    ? (variant === 'nocrit' ? <CriteriumSkeleton width='60%' /> : <Translate content='mobile_compatibility_ok' />)
    : (
      <>
        <Translate content='mobile_compatibility_ko' />
        <CriteriumTable
          fixedColumns={[20, 80]}
          head={head}
          rows={rows}
          showAmount={3}
          striped
          nowrap
        />
      </>
      );

  return (
    <Criterium
      criterium={criterium}
      variables={{ domain: url }}
    >
      {content}
    </Criterium>
  );
};

MobileCompatibility.propTypes = {
  criterium: PropTypes.shape({
    url: PropTypes.string,
    data: PropTypes.shape({
      plugins: PropTypes.arrayOf(
        PropTypes.object
      )
    })
  })
};

export default React.memo(MobileCompatibility);
